import React, { useCallback, useEffect, useState } from "react";

import Slider from "react-slick";
import {
  SVGIcons,
  ImgIcons,
  Imgbanner,
} from "../../Helpers/Common";
import { Link } from "react-router-dom";

var SVGIcon = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
var ImageData = "";
ImgIcons().then((result) => (ImageData = result));


export function Layout12(props) {
  // const [showShimmer, setShowShimmer] = useState(true);

  // const handleTimeout = useCallback(() => {
  //   setShowShimmer(false);
  // }, []);

  // useEffect(() => {
  //   // const timer = setTimeout(() => {
  //   setShowShimmer(false);
  //   // }, 1000);

  //   // return () => {
  //   //   clearTimeout(timer);
  //   // };
  // }, [handleTimeout]);

  return (
    <>
      <section className="mb-0">
        <div className="temp17 dD-none">
          {/* {showShimmer ? (
            <div className="line linehead" />
          ) : ( */}
          <>
            <div className="head">
              <h3>
                {props.title.display_title} <span className="red">{props.title.display_title_sufix}</span>
              </h3>
            </div>
          </>
          {/* )} */}
          {
            props.Layout1.map((data) => {
              var GenereTitle = data.genres.split(",");
              GenereTitle = GenereTitle[0];
              var keywords = data.keywords;
              var Age = data.age_restriction;
              var premium = "";
              var Isnewcontent;
              var video_url_4k = "";

              if (data.video_4k) {
                video_url_4k = <><div className="nBay nBay1" key={data.video_4k}>{data.video_4k}</div></>;
              } else {
                video_url_4k = <><div className="nBay nBay1">{data.video_hd}</div></>;
              }

              if (data.new) {
                Isnewcontent = <>New <span className="dot"> </span>{" "}</>;
              }

              if (data.awards && data.awards != null) {
                var awards = <><img src="img/svg/wincup.svg" /> Award Winning</>
              }
              var premium = <>
                <p>
                  {Isnewcontent}
                  {awards}
                </p>
                <h6>{data.keywords.split(',')[0]}</h6>
              </>;
              return (
                <>
                  {/* {showShimmer ? (
                    <div className="shimmerOriginal">
                      <img src={ImageData["placeholder3.png"]} alt="shimmer" className="shimmer" />
                      <div className="rightOriginal">
                        <div className="line" />
                        <div className="line" />
                        <div className="line" />
                        <div className="line" />
                        <div className="linebtn" />
                      </div>
                    </div>
                  ) : ( */}
                  <>
                    <div className="temp17-inner" key={data.slug}>
                      <Link to={"/" + data.slug}>
                        <div className="temp17-docBust">
                          <picture>
                            <source
                              srcSet={data.thumbnail_image1.large}
                              media="(min-width: 700px)"
                            />
                            <source
                              srcSet={data.thumbnail_image1.large}
                              media="(min-width: 820px)"
                            />
                            <source
                              srcSet={data.thumbnail_image1.large}
                              media="(min-width: 300px)"
                            />
                            <img src={data.thumbnail_image1.large} alt="" />
                          </picture>
                          {/* <img src={data.thumbnail_image1.medium} alt="DocBuster" /> */}
                          <img src={SVGIcon['play-2.svg']} className="docbus-btn" />
                        </div>
                      </Link>
                      <div className="temp17-award">
                        <div className="temp17-left">
                          <h4>{data.release_date}</h4>
                          <span className="dot" />
                          <h4>{data.duration / 60}  Mins</h4>
                        </div>
                        {premium}
                      </div>
                      <div className="temp17-inn">
                        <div className="nBay nBay2">{data.content_category} {Age}</div>
                        <div className="nBay">{GenereTitle}</div>
                        {video_url_4k}
                      </div>
                      <div className="temp17-text">
                        <h2>{data.title}</h2>
                        <p>
                          {data.short_description}
                        </p>
                      </div>
                      <Link to={"/" + data.slug}>
                        <button type="submit" id="sendEnquiryBtn" className="watch-nowBtn">
                          WATCH NOW
                        </button>
                      </Link>
                    </div>
                  </>
                  {/* )} */}
                </>
              )
            })
          }
        </div>
        <div className="temp17 dD-block">
          {/* {showShimmer ? (
            <div className="linedesk" />
          ) : ( */}
          <>
            <div className="head-layout">
              <h3>
                {props.title.display_title} <span className="red">{props.title.display_title_sufix}</span>
              </h3>
            </div>
          </>
          {/* )} */}
          {
            props.Layout1.map((data) => {
              var GenereTitle = data.genres.split(",");
              GenereTitle = GenereTitle[0];
              var keywords = data.keywords;
              var Age = data.age_restriction;
              var premium = "";
              var Isnewcontent;
              var video_url_4k = "";

              if (data.video_4k) {
                video_url_4k = <><div className="nBay nBay1">{data.video_4k}</div></>;
              } else {
                video_url_4k = <><div className="nBay nBay1">{data.video_hd}</div></>;
              }

              if (data.new) {
                Isnewcontent = <>New <span className="dot"> </span>{" "}</>;
              }

              if (data.awards && data.awards != null) {
                var awards = <><img src="img/svg/wincup.svg" /> Award Winning</>
              }

              var premium = <>
                <p>
                  {Isnewcontent}
                  {awards}
                </p>
                <h6>{data.keywords}</h6>
              </>

              return (
                <div className="temp17-inner" key={data.slug}>
                  {/* {showShimmer ? (
                    <div className="shimmerOriginal" style={{ margin: "10px 0px" }}>
                      <img src={ImageData["placeholder3.png"]} alt="shimmer" className="shimmer" />
                      <div className="rightOriginal" style={{ marginLeft: "40px" }}>
                        <div className="line" />
                        <div className="line" />
                        <div className="line" />
                        <div className="line" />
                        <div className="linebtn" />
                      </div>
                    </div>
                  ) : ( */}
                  <>
                    <Link to={"/" + data.slug}>
                      <div className="temp17-docBust">
                        <img src={data.thumbnail_image1.large} alt="DocBuster" />
                        <img src={SVGIcon['play-2.svg']} className="docbus-btn" />
                      </div>
                    </Link>
                    <div className="temp17-docBust-right">
                      <div className="temp17-award">
                        {/* {premium} */}
                        <div>{data.release_date}</div>&nbsp;
                        <span className="dot" />&nbsp;
                        <div>{data.duration / 60}  Mins</div>&nbsp;
                        <span className="dot" />&nbsp;&nbsp;
                        {data.keywords.split(',')[0]}
                      </div>
                      <div className="temp17-inn" style={{ display: "flex" }}>
                        {data.premium && !data.original_tag ? (
                          <img
                            src={props.silverIcon}
                            style={{
                              width: "24px",
                              marginRight: "6px",
                              marginBottom: "0px",
                            }}
                          />
                        ) : null}
                        {data.premium && data.original_tag ? (
                          <img
                            src={props.goldenOriginalIcon}
                            style={{
                              width: "9rem",
                              marginRight: "6px",
                              marginBottom: "0px",
                            }}
                          />
                        ) : null}
                        <div className="nBay nBay2">{data.content_category} {Age}</div>
                        <div className="nBay">{GenereTitle}</div>
                        {video_url_4k}
                      </div>
                      <div className="temp17-text">
                        <h2>{data.title}</h2>
                        <p>
                          {data.short_description}
                        </p>
                      </div>
                      <Link to={"/" + data.slug}>
                        <button type="submit" id="sendEnquiryBtn" className="watch-nowBtn">
                          WATCH NOW
                        </button>
                      </Link>
                    </div>
                  </>
                  {/* )} */}
                </div>
              )
            })}
        </div>
      </section>
    </>
  );
}

export default Layout12;
